module.exports = __webpack_public_path__ + "static/media/boiler-re-fit.ca022a56.png";